import React, { ReactElement } from "react";

import CheckPermissions from "../../CheckPermissions";

import { COMPONENTS } from "@utils/Constants";

export const AncillaryWTPApproachLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: AncillaryWTPApproach } = await import("@workflows/ancillaries/configurations/wtp-approach");
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ANCILLARIES_WTP_APPROACH}>
      <AncillaryWTPApproach />
    </CheckPermissions>
  );
  return { Component: WrappedRules };
};
